<template>
  <div class="business-left">
          <img src="~@/assets/business_img_l/bl1.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl2.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl3.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl4.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl5.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl6.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl7.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl8.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl9.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl10.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl11.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl12.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl13.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl14.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl15.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl16.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl17.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl18.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl19.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl20.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl21.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl22.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl23.jpg" class="changeImg" @click="changeImg()">
          <img src="~@/assets/business_img_l/bl24.jpg" class="changeImg" @click="changeImg()">
      </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  mounted () {
    this.changeImg()
  },
  methods: {
    // changeImg () {
    //   var address = document.getElementsByClassName('changeImg').src
    //   for (var i = 0; i < address.length; i++) {
    //     console.log(address[i] + '----------------')
    //   }
    // }
  }
}
</script>
<style>
.business-left{
  width: 100%;
}
@media screen and (min-width: 1500px){
  .business-left img{
    width: 16%;
    height: auto;
    cursor: pointer;
  }
}
@media screen and (min-width: 1200px) and (max-width:1499px){
  .business-left img{
    width: 14%;
    height: auto;
    cursor: pointer;
  }
}
@media screen and (min-width: 960px) and (max-width:1199px){
  .business-left img{
    width: 14%;
    height: auto;
    cursor: pointer;
  }
}
@media screen and (min-width: 768px) and (max-width:959px){
  .business-left img{
    width: 14%;
    height: auto;
    cursor: pointer;
  }
}
@media screen and (min-width: 702px) and (max-width:767px){
  .business-left img{
    width: 14%;
    height: auto;
    cursor: pointer;
  }
}
@media screen and (max-width:701px){
  .business-left img{
    width: 14%;
    height: auto;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/aboutMe/businessleft.vue